module.exports = __webpack_public_path__ + "0cb0b9c589c0624c9c78dd3d83e946f6.woff2";